<div class="space-y-6" [formGroup]="form()">
  <section class="space-y-4">
    <div class="grid gap-6 sm:grid-cols-2 xl:grid-cols-3">
      <ui-input
        [control]="form().controls.builtUpArea"
        label="Total Built-up Area"
        type="number"
        suffix="sq.ft"
        placeholder="3200"
        [required]="true"
      />

      <ui-input
        [control]="form().controls.ageYears"
        label="Building Age"
        type="number"
        suffix="years"
        placeholder="12"
        [required]="true"
        hint="Selects the age band in the building rate table."
      />

      <ui-select
        [control]="form().controls.constructionClass"
        label="Construction Classification"
        [options]="classOptions"
        [required]="true"
      />

      @if (needsRate()) {
        <div class="space-y-2">
          <ui-input
            [control]="form().controls.buildingRatePsf"
            label="Building Value / sq ft"
            type="number"
            prefix="₹"
            suffix="/sq.ft"
            [required]="true"
            [hint]="rateHint()"
          />
          @if (rateOutOfRange()) {
            <p class="text-xs font-medium text-red-600" role="alert">{{ rateHint() }}</p>
          }
        </div>
      }

      <ui-input
        [control]="form().controls.floors"
        label="Floors"
        type="number"
        placeholder="2"
      />
    </div>

    <div class="grid gap-4 sm:grid-cols-3">
      <ui-calculated-box
        label="Building Value / sq ft"
        [value]="psf(land()?.buildingRatePsf)"
        [derivation]="land()?.buildingAgeBand ? land()!.buildingAgeBand + ' · ' + (land()!.constructionClass ?? '') : 'Age band × construction class'"
      />
      <ui-calculated-box
        label="Total Building Value"
        [value]="compact(land()?.totalBuildingValue)"
        derivation="Built-up Area × Building Value / sq ft"
      />
      <ui-calculated-box
        label="Final Land Value"
        [value]="compact(land()?.finalLandValue)"
        derivation="From the Land Adjustments step"
      />
    </div>

    <ui-note-bar tone="info">
      Building rates (Basic / Premium): 0–3 yrs ₹1,750 / ₹2,500 · 4–7 yrs ₹1,250 / ₹1,800 ·
      8–12 yrs ₹750 / ₹1,250 · 13–15 yrs ₹250–500 / ₹500–750 · over 15 yrs ₹0.
    </ui-note-bar>
  </section>

  <section class="space-y-4">
    <ui-calculated-box
      label="Final CI Value (Circled Assessed Property Value)"
      [value]="compact(land()?.assessedValue)"
      [derivation]="finalCiFormula()"
    />
    <div class="grid gap-4 sm:grid-cols-3">
      <ui-calculated-box label="Ask vs CI Value" [value]="askVsCi()" derivation="Asking Price ÷ CI Value − 1" />
      <ui-calculated-box label="Suggested Offer" [value]="compact(result()?.suggestedOfferValue)" derivation="CI Value × 95%" />
      <ui-calculated-box label="Likely Closing Range" [value]="closingRange()" derivation="CI Value × 97% – 103%" />
    </div>
    <ui-calculated-box label="Customer Verdict" [value]="result()?.circledIntelligenceVerdict || '—'" [derivation]="result()?.verdictDescription || ''" />
  </section>

  @if (calculationError()) {
    <ui-note-bar tone="danger">{{ calculationError() }}</ui-note-bar>
  } @else if (calculating() && !land()) {
    <ui-note-bar tone="info">Calculating…</ui-note-bar>
  }
</div>
